<template lang="pug">
  #LabelCreate
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 編輯顧客喜好名單
    .container-width
      .p-3
        ValidationObserver.w-100(
          ref="form"
          tag="label"
          @submit.stop.prevent="submitHandler",
          class="mb-0"
        )
          b-form-group(
            class="mb-0"
          )
            ValidationProvider(
              rules="required",
              ref="inputValLabel"
            )
              label(
                for="label"
              )
                code *
                span 顧客喜好：
              b-input.d-inline-block(
                v-model="label",
                style="border-radius: 20px; background-color: #eee; font-weight: bold",
                placeholder="顧客喜好",
                :disabled=" mode === 'backend'"
              )
              .d-flex
                b-row(
                  no-gutters,
                  class="w-100"
                )
                  b-col(
                    cols=10
                  )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback",
                      :class="validState('label') === null || validState('label') === true ? 'd-none' : 'd-block'"
                    )
                      span 此欄不可為空且字數需小於30個字元
                  b-col(
                    :cols="validState('label') ? 12 : 2"
                  )
                    small.d-block.text-right
                      small(
                        :class="{ 'text-danger': label !== null && label.length > 30 }"
                      ) {{ label !== null ? label.length : 0 }}
                      | /30

        p 顧客喜好內共
          code.px-1 {{ selectUsers.length }}
          | 位名單
        .row.mb-5.word-break-all
          .col-3(
            v-for="(user,index) in selectUsers",
            :key="user.member_id"
          ) 
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :id="user.member_id",
              :profileUrl="user.picture_url",
              :cancelProfile="true"
              :style="{ 'width': '70px', 'height': '70px' }"
              @cancelProfileImgHandler="cancelProfileHandler",
              @imgHandler="toMemberHandler"
            )
            small.d-block.text-center.mt-1 {{ user.line_display_name }}
          .col-3.text-center
            .border.border-gray-light-2.bg-gray-light.rounded-circle.mx-auto.d-flex.align-items-center.justify-content-center.mb-1(
              style="width: 70px;height: 70px;",
              @click="openUsersModelHandler()"
            )
              i.fas.fa-plus.text-disable-light.fa-lg
            small.d-block.text-center 新增名單
        .row.d-flex.justify-content-center
          .col-6
            b-button.py-1.font-weight-bold.btn-custom(
              variant="remind",
              block,
              @click="submitHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 10px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 儲存編輯
    usersModel(
      title="顧客喜好名單"
    )
    aboutMemberModel(
      title="我的顧客"
    )
</template>

<script>
import { mapState } from 'vuex';
import { SA_LABEL_INDEX } from '@/router/sa/label';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import usersModel from '@/components/customerModel/usersModel.vue';
import aboutMemberModel from '@/components/customerModel/aboutMemberModel.vue';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'LabelEdit',
  components: {
    ValidationProvider,
    ValidationObserver,
    usersModel,
    aboutMemberModel,
    ProfilePhotoSticker
  },
  props: {
    tag_id: {
      type: [String, Number],
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      label: null
    };
  },
  // 完成功能後要拿掉
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    // 初始化全部
    vm.$store.commit('sa_label/resetAll');
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });

    let apiTarget;

    switch (vm.mode) {
      case 'ba':
        apiTarget = 'showTagHandler';
        break;
      case 'backend':
        apiTarget = 'showBackendTagHandler';
        break;
      default:
        break;
    }

    if (!vm.mode || !apiTarget) {
        vm.$swal.fire({
        icon: 'error',
        title: '編輯目標錯誤[Err: Not Has NowSelect]'
      });
      return;
    }

    vm.$store.dispatch(`sa_label/${apiTarget}`, {
      tag_id: vm.tag_id
    })
      .then((res) => {
        vm.$swal.close();
        vm.label = res.tag_name;
        vm.$store.commit('sa_label/setSelectUsers', res.has_tag_members);
      });
  },
  methods: {
    validState() {
      const vm = this;
      if (vm.label !== null) {
        return vm.label.length < 30 && vm.label.length > 0 ? true : false;
      }
      return null;
    },
    openUsersModelHandler() {
      this.$EventBus.$emit('openUsersModel', this.mode);
    },
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.label === null) {
          vm.label = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        vm.$swal.fire({
          title: '編輯顧客喜好中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        const member_ids = [];

        _.forEach(vm.selectUsers, (res) => {
          member_ids.push(res.member_id);
        });

        let apiTarget;
        const sendInfo = {
          tag_id: vm.tag_id,
          member_ids
        };

        switch (vm.mode) {
          case 'ba':
            apiTarget = 'updateTagHandler';
            sendInfo.tag_name = vm.label;
            break;
          case 'backend':
            apiTarget = 'updateBackendTagHandler';
            break;
          default:
            break;
        }

        if (!vm.mode || !apiTarget) {
           vm.$swal.fire({
            icon: 'error',
            title: '編輯目標錯誤[Err: Not Has NowSelect]'
          });
          return;
        }

        vm.$store.dispatch(`sa_label/${apiTarget}`, sendInfo)
          .then(() => {
            vm.$swal.close();
            vm.resetAllHandler();
            vm.$router.push({
              name: SA_LABEL_INDEX
            });
          });
      }
    },
    cancelProfileHandler(id) {
      const vm = this;
      const key = _.findKey(vm.selectUsers, (user) => user.member_id === id);
      vm.$store.commit('sa_label/removeSelectUsers', key);
    },
    toMemberHandler(userId) {
     this.$EventBus.$emit('openAboutMemberModel', userId);
    },
    resetAllHandler() {
      const vm = this;
      vm.$store.commit('sa_label/resetAll');
      vm.$router.push({ name: 'sa-label-index' });
    },
    routerBack() {
      this.$router.back();
    }
  },
  computed: {
    ...mapState({
      selectUsers: (state) => state.sa_label.selectUsers
    })
  }
};
</script>

<style scoped>
  @font-face {
    font-family: "icon";
    src: url("../../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  #header_back {
    font-size: 1.7rem;
    padding: 0.5rem;
    position: absolute;
    top: 3%;
    left: 1.6rem;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: #fff !important;
    z-index: 15;
  }

  i.custom {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-icon_arrowLeft {
    top: 0;
    left: 5px;
  }

  .icon-icon_arrowLeft:before {
    content: "\e907";
  }
</style>
